import { render, staticRenderFns } from "./TicketModal.vue?vue&type=template&id=a0c5c3a4&scoped=true&"
import script from "./TicketModal.vue?vue&type=script&lang=js&"
export * from "./TicketModal.vue?vue&type=script&lang=js&"
import style0 from "./TicketModal.vue?vue&type=style&index=0&id=a0c5c3a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c5c3a4",
  null
  
)

export default component.exports